'use client'

import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { cn } from '@/lib/utils'
import { useConfirmStore } from '@/stores/confirm.store'
import { useTranslations } from 'next-intl'

export function ConfirmDialog() {
  const { state, handleConfirm, handleCancel, handleClose } = useConfirmStore()
  const t = useTranslations('button')

  return (
    <Dialog open={state.isOpen} onOpenChange={(open) => !open && handleClose()}>
      <DialogContent className='max-w-[90%] rounded-xl border-0 p-4 px-8 shadow md:w-fit md:px-10'>
        <DialogHeader>
          <DialogTitle className='text-center font-criteria text-xl'>
            {state.title}
          </DialogTitle>
          {state.description && (
            <DialogDescription className='text-center text-neutral-800/60'>
              {state.description}
            </DialogDescription>
          )}
        </DialogHeader>
        <DialogFooter
          className={cn(
            'mt-4 flex flex-row items-center gap-2 sm:justify-end md:justify-center',
            state.footerClassName
          )}
        >
          <Button
            variant='outline-neutral'
            onClick={handleCancel}
            className={cn(
              'flex-1 !h-10 text-sm sm:w-auto',
              state.cancelButtonClassName
            )}
          >
            {state.cancelText || t('cancel')}
          </Button>
          {state.confirmButtonClassName ? (
            <div className='group relative flex-[1.5] sm:w-auto'>
              <Button
                onClick={handleConfirm}
                className={cn(
                  state.confirmButtonClassName,
                  'relative z-10 w-full min-w-0 overflow-hidden !h-10 text-sm'
                )}
              >
                <span className='relative z-20 truncate'>
                  {state.confirmText || t('confirm')}
                </span>
                {/* Shimmer effect */}
                <div className='absolute inset-0 z-0 -translate-x-full bg-gradient-to-r from-transparent via-[#d6ff01]/30 to-transparent transition-transform duration-1000 ease-in-out group-hover:translate-x-full' />
                {/* Inner glow */}
                <div className='absolute inset-0 z-10 rounded-lg bg-gradient-to-br from-[#d6ff01]/5 via-transparent to-[#d6ff01]/5 opacity-0 transition-opacity duration-300 group-hover:opacity-100' />
              </Button>
            </div>
          ) : (
            <Button
              variant='black'
              onClick={handleConfirm}
              className='flex-[1.5] !h-10 text-sm sm:w-auto'
            >
              {state.confirmText || t('confirm')}
            </Button>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
